import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import getTranslatedCollection from 'ha/utils/urls/getTranslatedCollection';
import removeTrailingSlash from 'ha/utils/urls/removeTrailingSlash';
import { ROOM_FOR_RENT } from 'ha/utils/urls/deprecatedRoutes';

export default store => (nextState, replace, callback) => {
  const collection = nextState.params.localizedKind;

  let pathname = removeTrailingSlash(nextState.location.pathname);
  const language = getCurrentLanguageCode(store.getState());

  if (ROOM_FOR_RENT.includes(collection)) {
    const currentCollection = getTranslatedCollection(
      language,
      'private-rooms',
    );

    replace({
      ...nextState.location,
      pathname: pathname.replace(collection, currentCollection),
    });

    return callback();
  }

  if (collection) {
    const translatedCollection = getTranslatedCollection(
      language,
      encodeURIComponent(collection),
    );

    if (translatedCollection) {
      pathname = pathname.replace(collection, translatedCollection);
    }
  }

  if (nextState.location.pathname !== pathname) {
    replace({
      ...nextState.location,
      pathname,
    });
  }

  return callback();
};
